import axios from './customAxios';

const carnetVacunacionProvider = {
    carnetvacunacion: async(ficha) => {
        return await axios.post('/carnetvacunacion/Registrar_Actualizar_Archivo', ficha);
    },
    listarcarnetvacunacionpaginado: async(request) => {
        return await axios.post('/carnetvacunacion/ListarCarnetVacunacionPaginado', request);
    },
    validar_carnetvacunacion_por_nro_documento: async(body) => {
        return await axios.post('/carnetvacunacion/Validar_carnetvacunacion_por_nro_documento', body);
    },
    obtenercarnetvacunacionporid: async(request) => {
        return await axios.post('/carnetvacunacion/ObtenerCarnetVacunacionPorId', request);
    },
    Dar_Baja_CarnetVacunacion: async(request) => {
        return await axios.post('/carnetvacunacion/Dar_Baja_CarnetVacunacion', request);
    },
    ObtenerAdjuntoCarnetVacunacionPorId: async(id) => {
        return await axios.get('/carnetvacunacion/ObtenerAdjuntoCarnetVacunacionPorId/' + id, {
            responseType: 'blob'
        });
    },
    ListarAdjuntoCarnetVacunacionPorIdCarnet: async(request) => {
        return await axios.post('/carnetvacunacion/ListarAdjuntoCarnetVacunacionPorIdCarnet', request);
    }
};

export default carnetVacunacionProvider;